module.exports = __webpack_public_path__ + "img/PaulCroeger.9d489d0b.png";